'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/react/react.js
// module id = 25
// module chunks = 0